import axios from "axios";
import config from "../app.json";
import "react-toggle/style.css";
import "./Styles/receipts.scss";

import React, { useRef, useState, useEffect } from "react";
import Pill from "../Components/Pill/pill";
import Moment from "react-moment";
import PaginationTable from "../Components/PaginationTable/pagination-table";
import { Anchor } from "react-bootstrap";

function Receipts(props) {
  const [data, setData] = useState([]);
  const [gridLoading, setGridLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(3);
  const [total, setTotal] = useState(0);
  const [sort, setSort] = useState({}); // estado de classificação da tabela

  const handleSort = (column, sortDirection) => {
    setSort({ column, sortDirection });
  };

  const sortedData = React.useMemo(() => {
    if (!sort.column) return data;

    const sorted = [...data].sort((a, b) => {
      if (a[sort.column.id] < b[sort.column.id]) {
        return sort.sortDirection === "asc" ? -1 : 1;
      }
      if (a[sort.column.id] > b[sort.column.id]) {
        return sort.sortDirection === "asc" ? 1 : -1;
      }
      return 0;
    });

    return sorted;
  }, [data, sort]);

  // On page change, fetch data again
  useEffect(() => {
    fetchData();
  }, [0]);

  const formatCurrency = ({
    value,
    locale = "en-US",
    style = "currency",
    currency = "USD",
  }) => {
    return Intl.NumberFormat(locale, {
      style,
      currency,
    }).format(value);
  };

  const columns = [
    {
      id: "date",
      name: "Payout Date",
      sortable: true,
      center: false,
      cell: (row) => <Moment format="MMM, D YYYY" date={row.dateUTC} />,
    },
    {
      id: "ammount",
      name: "Amount",
      center: false,
      sortable: true,
      cell: (row) => formatCurrency({ value: row.ammount }),
    },
    {
      name: "Status",
      center: false,
      cell: (row) => (
        <div className="pills">
          <Pill title={row.status} key={row.id} />
        </div>
      ),
    },
    {
      name: "Actions",
      center: false,
      cell: (row) => row.receiptUrl ? (
        <div className="pills">
          <Anchor variant="link" href={row.receiptUrl} target="_blank" className="pill" >
            Invoices
          </Anchor>
        </div>
      ) : null,
    },
  ];


  async function fetchData() {
    var currentFilter = {
      page: page - 1,
      perPage,
      sortField: sort?.id ?? `id`,
      sortDirection: sort?.direction ?? `asc`
    };

    sessionStorage.setItem("receipt_grid", JSON.stringify(currentFilter));
    setGridLoading(true);

    await axios.post(config.API + "/api/Payment/getStripePayments", { currentFilter }).then((res) => {
      const receipts = res.data.$values;
      setTotal(receipts.length);
      setData(receipts);
      setGridLoading(false);
    }).catch(function (error) {
      alert(error?.response?.data?.error || error?.message);
    }).finally(function () {
      setGridLoading(false);
    });
  }

  const handleGridPerPage = (page) => {
    setChangedViaPerPage(true);
    setPage(1);
    setPerPage(page);
  };

  return (
    <div className="download-invoices">
      <h3>Download Invoices</h3>
      <PaginationTable
        className={`receipts`}
        defaultSortFieldId={`receiptName`}
        columns={columns}
        data={sortedData?.slice((page - 1) * perPage, page * perPage)}
        gridLoading={gridLoading}
        perPage={perPage}
        page={page}
        total={total}
        setPerPage={handleGridPerPage}
        setPage={setPage}
        header={`Receipts`}
        onSort={handleSort}
        sort={sort}
        displayRowPerPage={false}
        showHeader={false}
      />
    </div>

  );
}

export default Receipts;
